import React from "react";
import classNames from "classnames";
import {
  GOVGR_DRAWER_BURGER_ICON,
  GOVGR_SVG_ICON,
  GOVGR_BTN_SECONDARY_CUSTOM_COLOR,
  GOVGR_BTN,
  GOVGR_BURGER_ICON,
} from "../../conf/styles/GovGrDrawerMenu";

const HambugerMenu = ({ hiddenbutton, openmenu, hiddenmenu }) => {
  const buttonClassName = classNames(
    GOVGR_DRAWER_BURGER_ICON,
    GOVGR_BTN_SECONDARY_CUSTOM_COLOR,
    GOVGR_BTN,
    "m-0",
    { hidden: hiddenmenu || hiddenbutton }
  );
  const hiddenHamburgerMenu = hiddenmenu || hiddenbutton;
  return (
    <>
      {hiddenHamburgerMenu ? (
        <></>
      ) : (
        <button className={buttonClassName} onClick={openmenu}>
          <svg
            className={`${GOVGR_BURGER_ICON} ${GOVGR_SVG_ICON}`}
            focusable="false"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <rect id="govgr-burger-icon__line-1" width="24" height="3.3"></rect>
            <rect id="govgr-burger-icon__line-2" width="24" height="3.3"></rect>
            <rect id="govgr-burger-icon__line-3" width="24" height="3.3"></rect>
          </svg>
        </button>
      )}
    </>
  );
};

export default HambugerMenu;
